import { DataService } from './../../../../services/data.service';
import { FormControl } from '@angular/forms';
import { User } from './../../../../interfaces/user';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';

@Component({
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  users: User[];
  showData: any[];

  currentPage = 1;
  totalItemsPerPage = 20;

  showSettings = false;

  searchForm = new FormControl('');
  userFilter = 0;

  constructor(
    private toastr: ToastrService,
    private data: DataService
  ) { }

  ngOnInit() {
    this.searchForm.valueChanges.subscribe(async (v) => {
      this.showData = _.filter(this.users, (i) => {
        const regex = new RegExp(v, 'gi');

        if(this.userFilter !== 0 && i.type !== this.userFilter){
          return false;
        }

        if(!v){
          return true;
        }

        return String.prototype.search.call(i.auto_id, regex) !== -1 || String.prototype.search.call(i.name, regex) !== -1;
      });
    })

    this.data.getUsers().subscribe((res) => {
      if(res && res.data){
        this.users = res.data;
        this.showData = res.data;
      }
    })
  }

  async delete(id){
    this.data.deleteUser(id).subscribe();
  }

  filterUsers({value}){
    let data = this.users;

    this.userFilter = value;

    if(this.searchForm.value){
      data = _.filter(data, (i) => {
        const regex = new RegExp(this.searchForm.value, 'gi');

        return String.prototype.search.call(i.auto_id, regex) !== -1 || String.prototype.search.call(i.name, regex) !== -1;
      });
    }

    this.showData = value === 0 ? data : _.filter(data, {type: value});
  }
}
